export default {"src":"/_next/static/image/public/images/plusicon.fbc215ed6fdc62dc193bc8e0aa0a61c8.svg","height":20,"width":21};